import React from "react";
import PropTypes from "prop-types";
import { getStoryHeadline, getStoryLabel } from "../../../utils/story";
import "./story-card.m.css";
import { Label } from "../../../atoms/Label";
import Headline from "../../../atoms/Headline";
import SubHeadline from "../../../atoms/SubHeadline";

const CardInfo = ({ story, isHeroStory, showSubheadline, sectionSlug }) => {
  const headline = getStoryHeadline(story);
  const label = getStoryLabel(story);
  return (
    <div styleName={`${isHeroStory ? "hero-headline-container" : "headline-container"}`}>
      {label && <Label story={story} />}

      {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}
      {showSubheadline && story?.subheadline && (
        <SubHeadline styleName="sub-headline" subHeadline={story?.subheadline} sectionSlug={sectionSlug} />
      )}
    </div>
  );
};

CardInfo.propTypes = {
  story: PropTypes.shape({
    subheadline: PropTypes.string,
  }),
  showSubheadline: PropTypes.bool,
  isHeroStory: PropTypes.bool,
  sectionSlug: PropTypes.string,
};

export default CardInfo;
